<div class="w-100">
    <canvas #chart></canvas>
</div>
